import { useState, useEffect } from 'react';

import { InitialsAvatar, RowPhoto } from '../styles';

// Panel kart satırlarının avatarı (İzin Paneli'nin RowAvatar'ının kopyası — panel başına kendi kabuğu).
// Kural: kişi listelenen HER yerde profil fotoğrafı varsa o; yoksa (ya da adres kırıksa) baş-harf rozeti.
export function initialsOf(name) {
  return (name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toLocaleUpperCase('tr'))
    .join('');
}

export default function RowAvatar({ src, name, size }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [src]);

  if (src && !broken) {
    return <RowPhoto $size={size} src={src} alt={name || ''} onError={() => setBroken(true)} />;
  }
  return <InitialsAvatar $size={size}>{initialsOf(name)}</InitialsAvatar>;
}
